/** @format */

import React from 'react'
import { _$, Card } from '@king-design/react' // , Tabs, Tab
import { CustomPageContainer } from 'src/components'
import Customboard from './Customboard'
import styled from 'styled-components'
// import Cloudboard from './Cloudboard'

const DashboardList: React.FC<{ className?: string }> = ({ className }) => {
  // const [tabValue, setTabValue] = useState<'customboar' | 'cloudboard'>('customboar')
  return (
    <div className={className}>
      <CustomPageContainer title={_$('Dashboard')}>
        <Card type="none">
          <Customboard />
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(DashboardList)``
